import { IdConnectDataType, UID, UtiqOpenRtbEids } from '@idConnect/types';
import { NetidUtiqAdtechpass } from '@shared/constants/utiq';

/**
 * Builds the "Utiq OpenRTB EIDs" structure from the given idGraph data.
 * @param idConnectData  - The source object containing the idGraph information.
 * @returns An array of UtiqOpenRtbEids objects, or null if the input is invalid.
 */
export const getUtiqOpenRtbEids = (
  idConnectData: IdConnectDataType | null = null,
): UtiqOpenRtbEids[] | null => {
  const uids: UID[] = [];
  const insertIdgraphIds = (data: IdConnectDataType | null) => {
    if (
      data &&
      data.connectId &&
      Array.isArray(data.connectId.idGraph) &&
      data.connectId.idGraph.length > 0
    ) {
      data.connectId?.idGraph.forEach((idGraphIds) => {
        if (idGraphIds.atid) {
          uids.push({
            id: idGraphIds.atid,
            atype: 1,
            ext: { utiq: { category: idGraphIds.category } },
          });
        }
      });
    }
  };
  if (idConnectData === null) {
    const utiqPass = JSON.parse(localStorage.getItem('utiqPass')!);
    insertIdgraphIds(utiqPass);
  } else {
    insertIdgraphIds(idConnectData);
  }
  const netIdAdtechpass = localStorage.getItem(NetidUtiqAdtechpass);
  if (netIdAdtechpass) {
    uids.push({
      id: netIdAdtechpass,
      atype: 1,
      ext: { utiq: { category: 'netid' } },
    });
  }
  if (uids.length > 0) {
    return [
      {
        source: 'utiq.com',
        uids,
      },
    ];
  }
  return null;
};
